@if (navItem?.show) {
  <li
    class="min-h-[47px] my-1.5 overflow-hidden"
    [class.rounded-lg]="!navItem?.child"
    [class.bg-neutral-100]="this.expanded && !navItem?.child"
  >
    @if (navItem?.link) {
      @if (navItem?.typeNavigation === 'internal') {
        <a
          [routerLink]="navItem?.link"
          routerLinkActive="bg-neutral-200"
          [style.paddingLeft.px]="depth === 0 ? 16 : depth * 25"
          class="flex items-center hover:bg-neutral-200 px-4 py-2.5 rounded-lg cursor-pointer w-full text-gray-600"
        >
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </a>
      } @else {
        <a
          [href]="navItem?.link"
          target="_self"
          [style.paddingLeft.px]="depth === 0 ? 16 : depth * 25"
          class="flex items-center hover:bg-neutral-200 px-4 py-2.5 rounded-lg cursor-pointer w-full text-gray-600"
        >
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </a>
      }
    } @else {
      <button
        [style.paddingLeft.px]="depth === 0 ? 16 : depth * 25"
        class="flex items-center hover:bg-neutral-200 px-4 py-2.5 rounded-lg cursor-pointer w-full text-gray-600"
        (click)="toggleItem()"
      >
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </button>
    }

    <ng-template #content>
      @if (navItem?.icon && depth === 0) {
        @if (navItem?.isSvgIcon) {
          <mat-icon [svgIcon]="$any(navItem).icon" class="mr-4 w-fit h-fit color-hotel"> </mat-icon>
        } @else {
          <mat-icon fontSet="material-icons-outlined" class="mr-4 w-fit h-fit color-hotel">
            {{ navItem?.icon }}
          </mat-icon>
        }
      }

      <p class="text-sm">
        {{ navItem!.name }}
      </p>

      @if (navItem?.child) {
        <div class="flex-1"></div>
        <mat-icon ctrHotelColor [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'"> expand_more </mat-icon>
      }
    </ng-template>

    @if (navItem?.child && expanded) {
      <ul class="bg-neutral-100 rounded-lg">
        @for (child of navItem?.child; track child.link) {
          <ctr-menu-item [navItem]="child" [depth]="depth + 1"></ctr-menu-item>
        }
      </ul>
    }
  </li>
}
